export default {
  getAutomation(state) {
    return state.automation;
  },
  getAutomations(state) {
    return state.automations;
  },
};
